<template>
  <div class="navtab">
    <div class="navtab__box">
      <ul>
        <li v-for="(item, index) in navItems" :key="index" class="navtab__box--list main semi-bold" :class="{ 'active' : selectedItem == item }" @click="itemSelected(item)">
          <app-link :id="item.linkId" :type="item.pageType">
            {{ item.title }}
          </app-link>
        </li>
      </ul>
    </div>
    <div v-if="!showExperiences" class="navtab__box">
      <div v-if="selectedItem && selectedItem.subheading" class="navtab__box--subheading">
        {{ selectedItem.subheading }}
      </div>
      <ul v-if="selectedItem && selectedItem.submenu">
        <li v-for="(item, i) in selectedItem.submenu" :key="i" class="navtab__box--list" :class="{ 'active' : selectedSubMenu == item }" @click="selectedSubMenu = item">
          <app-link :id="item.linkId" :type="item.pageType" :class="{ 'uppercase' : item.submenu }">
            {{ item.title }}
          </app-link>
        </li>
      </ul>
    </div>
    <div v-if="!showExperiences" class="navtab__box">
      <ul v-if="selectedSubMenu && selectedSubMenu.submenu" :class="{ 'columns' : selectedSubMenu.title == 'Greece'}">
        <li v-for="(item, j) in selectedSubMenu.submenu" :key="j" class="navtab__box--list tertiary" :class="{ 'active' : tertiaryMenu == item }" @click="tertiaryMenu = item">
          <app-link :id="item.linkId" :type="item.pageType">
            {{ item.title }}
          </app-link>
        </li>
      </ul>
    </div>

    <!-- EXPERIENCES -->
    <div v-for="(item, ind) in selectedItem.submenu" v-else :key="ind" class="navtab__box">
      <div class="navtab__box--subheading">
        {{ item.title }}
      </div>
      <ul>
        <li v-for="(experience, i) in item.submenu" :key="i" class="navtab__box--list">
          <app-link :id="experience.linkId" :type="experience.pageType">
            {{ experience.title }}
          </app-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import HamburgerContent from './HamburgerContent';

export default {
  data() {
    return {
      selectedItem: null,
      selectedSubMenu: null,
      tertiaryMenu: null,
      showExperiences: null,
    };
  },
  computed: {
    navItems() {
      return HamburgerContent.filter((item) => item.mobileOnly != true);
    },
  },
  watch: {
    $route() {
      this.reset();
    },
  },
  methods: {
    logout() {
      this.$store.dispatch('users/logOut');
    },
    reset() {
      this.selectedItem = null;
      this.selectedSubMenu = null;
      this.tertiaryMenu = null;
      this.showExperiences = null;
    },
    itemSelected(item) {
      this.selectedItem = item;
      this.selectedSubMenu = null;
      item.id == 2 ? this.showExperiences = item : this.showExperiences = null;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/styles/settings/config.scss";

.navtab {
  &__box {
    &--list {
      display: block;
      width: fit-content;
      &.main{
        text-transform: uppercase;
        font-size: 16px;
      }
      &.tertiary {
        margin-bottom: 8px;
      }
      & a {
        color: inherit;
      }
    }
    &--subheading {
      text-transform: uppercase;
      font-size: 14px;
      font-weight: 500;
      margin-bottom: 32px;
    }
  }
}

.columns {
  columns: 2;
  column-gap: 0.5rem;
}

</style>
